import { render, staticRenderFns } from "./CarDataBox.vue?vue&type=template&id=e414d7c4&"
import script from "./CarDataBox.vue?vue&type=script&lang=js&"
export * from "./CarDataBox.vue?vue&type=script&lang=js&"
import style0 from "./CarDataBox.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports